<template>
    <div>
        <div v-if="listOfMetadataRepresentations.length > 0" class="panel panel-default table-of-contents margin-above">
            <div class="panel-heading">
                <h4>Jump to items</h4>
            </div>
            <div class="list-style-type-none" v-for="(content, contentIndex) in listOfMetadataRepresentations" :key="contentIndex">
                <table-element :content="content" />
            </div>
        </div>
    </div>
</template>

<script>
import TableElement from "./TableElement.vue"
export default {
    name: "TableOfContents",
    components: {
        TableElement,
    },
    props: {
        listOfMetadataRepresentations: {
            type: Array,
            required: true,
        }
    },
}
</script>

<style scoped>
.list-style-type-none {
    list-style-type: none;
}
</style>
